<template>
    <div>
        <div v-for="field, fieldIndex in fields">

            <InputInstanceSelector
                    :ref="field.id"
                    v-if="field.type === 'instanceSelector'"
                    :id="field.id"
                    :label="field.label"
                    :form="form"
                    :search="field.search"
                    :emptyMessage="field.emptyMessage"
                    :required="field.required"
                    :fieldRefs="fieldRefs"
                    :_isVisible="field.isVisible"
                    :instanceSelector="field.instanceSelector"
                    :description="field.description"
                    v-model="form[field.id].$model">
            </InputInstanceSelector>

            <InputMultipleInstanceSelector
                    :ref="field.id"
                    v-if="field.type === 'multipleInstanceSelector'"
                    :id="field.id"
                    :label="field.label"
                    :form="form"
                    :emptyMessage="field.emptyMessage"
                    :required="field.required"
                    :fieldRefs="fieldRefs"
                    :_isVisible="field.isVisible"
                    :instanceSelector="field.instanceSelector"
                    :description="field.description"
                    v-model="form[field.id].$model">
            </InputMultipleInstanceSelector>

            <InputSignature
                    :ref="field.id"
                    v-if="field.type === 'signature'"
                    :id="field.id"
                    :label="field.label"
                    :form="form"
                    :fieldRefs="fieldRefs"
                    :required="field.required"
                    :_isVisible="field.isVisible"
                    :description="field.description"
                    v-model="form[field.id].$model">
            </InputSignature>

            <InputSignatureImage
                    :ref="field.id"
                    v-if="field.type === 'signatureImage'"
                    :id="field.id"
                    :label="field.label"
                    :form="form"
                    :fieldRefs="fieldRefs"
                    :required="field.required"
                    :_isVisible="field.isVisible"
                    :description="field.description"
                    v-model="form[field.id].$model">
            </InputSignatureImage>

            <Alert
                    :ref="field.id"
                    v-if="field.type === 'alert'"
                    :id="field.id"
                    :alert="field.alert">
            </Alert>

            <ActionButton
                    :ref="field.id"
                    v-if="field.type === 'actionButton'"
                    :id="field.id"
                    :label="field.label"
                    :_isVisible="field.isVisible"
                    :buttonClass="field.buttonClass"
                    :iconClass="field.iconClass"
                    @onClick="field.onClick"
                    :description="field.description">
            </ActionButton>

            <RequestButton
                    :ref="field.id"
                    v-if="field.type === 'requestButton'"
                    :id="field.id"
                    :label="field.label"
                    :buttonClass="field.buttonClass"
                    :root="field.root"
                    :method="field.method"
                    :_isVisible="field.isVisible"
                    :iconClass="field.iconClass"
                    @onRequestSuccess="field.onRequestSuccess"
                    @onRequestError="field.onRequestError"
                    :description="field.description">
            </RequestButton>

            <InputText
                    :ref="field.id"
                    v-if="field.type === 'text'"
                    :id="field.id"
                    :label="field.label"
                    :form="form"
                    :required="field.required"
                    :placeholder="field.placeholder"
                    :autocomplete="field.autocomplete"
                    :description="field.description"
                    :labelCols="field.labelCols"
                    :fieldRefs="fieldRefs"
                    :multiLingual="field.multiLingual"
                    :_isVisible="field.isVisible"
                    :invalidFeedbackMessage="field.invalidFeedbackMessage"
                    v-model="form[field.id].$model"></InputText>

            <InputHTML
                    :ref="field.id"
                    v-if="field.type === 'html'"
                    :id="field.id"
                    :label="field.label"
                    :form="form"
                    :description="field.description"
                    :labelCols="field.labelCols"
                    :fieldRefs="fieldRefs"
                    v-model="form[field.id].$model"
                    :_isVisible="field.isVisible"></InputHTML>

            <InputItems
                    :ref="field.id"
                    v-if="field.type === 'items'"
                    :fields="field.fields"
                    :columns="field.columns"
                    :id="field.id"
                    :form="form"
                    :addLabel="field.addLabel"
                    :description="field.description"
                    :_isVisible="field.isVisible"
                    v-model="form[field.id].$model"></InputItems>

            <InputAddress
                    :ref="field.id"
                    v-if="field.type === 'address'"
                    :id="field.id"
                    :label="field.label"
                    :form="form"
                    v-model="form[field.id].$model"></InputAddress>

            <InputNotes
                    :ref="field.id"
                    v-if="field.type === 'notes'"
                    :id="field.id"
                    :form="form"
                    v-model="form[field.id].$model"></InputNotes>

            <InputDate
                    :ref="field.id"
                    v-if="field.type === 'date'"
                    :id="field.id"
                    :label="field.label"
                    :form="form"
                    :required="field.required"
                    :placeholder="field.placeholder"
                    :autocomplete="field.autocomplete"
                    :description="field.description"
                    :labelCols="field.labelCols"
                    :_isVisible="field.isVisible"
                    :invalidFeedbackMessage="field.invalidFeedbackMessage"
                    v-model="form[field.id].$model"></InputDate>

            <InputText
                    :ref="field.id"
                    v-if="field.type === 'email'"
                    :id="field.id"
                    :label="field.label"
                    :form="form"
                    :labelCols="field.labelCols"
                    :required="field.required"
                    :placeholder="field.placeholder"
                    :autocomplete="field.autocomplete"
                    :description="field.description"
                    :_isVisible="field.isVisible"
                    :invalidFeedbackMessage="field.invalidFeedbackMessage"
                    v-model="form[field.id].$model"></InputText>

            <InputScanText
                    :ref="field.id"
                    v-if="field.type === 'scanText'"
                    :id="field.id"
                    :label="field.label"
                    :form="form"
                    :labelCols="field.labelCols"
                    :required="field.required"
                    :placeholder="field.placeholder"
                    :autocomplete="field.autocomplete"
                    :description="field.description"
                    :invalidFeedbackMessage="field.invalidFeedbackMessage"
                    v-model="form[field.id].$model"></InputScanText>

            <InputHidden
                    :ref="field.id"
                    v-if="field.type === 'hidden'"
                    :id="field.id"
                    :form="form"
                    v-model="form[field.id].$model"></InputHidden>

            <InputPassword
                    :ref="field.id"
                    v-if="field.type === 'password'"
                    :id="field.id"
                    :label="field.label"
                    :form="form"
                    :labelCols="field.labelCols"
                    :required="field.required"
                    :readable="field.readable"
                    :placeholder="field.placeholder"
                    :autoGenerateOption="field.autoGenerateOption"
                    :autocomplete="field.autocomplete"
                    :description="field.description"
                    :invalidFeedbackMessage="field.invalidFeedbackMessage"
                    :_isVisible="field.isVisible"
                    v-model="form[field.id].$model"></InputPassword>

            <InputSelect
                    :ref="field.id"
                    v-if="field.type === 'select' && field.onSelect !== false"
                    :id="field.id"
                    :label="field.label"
                    :options="field.options"
                    :form="form"
                    :labelCols="field.labelCols"
                    :placeholder="field.placeholder"
                    :required="field.required"
                    :autocomplete="field.autocomplete"
                    :description="field.description"
                    :search="field.search"
                    :_isVisible="field.isVisible"
                    @onSelect="field.onSelect"
                    :fieldRefs="fieldRefs"
                    :invalidFeedbackMessage="field.invalidFeedbackMessage"
                    v-model="form[field.id].$model"></InputSelect>

            <InputSelect
                    :ref="field.id"
                    v-if="field.type === 'select' && field.onSelect === false"
                    :id="field.id"
                    :label="field.label"
                    :options="field.options"
                    :form="form"
                    :labelCols="field.labelCols"
                    :placeholder="field.placeholder"
                    :required="field.required"
                    :autocomplete="field.autocomplete"
                    :description="field.description"
                    :search="field.search"
                    :_isVisible="field.isVisible"
                    :fieldRefs="fieldRefs"
                    :invalidFeedbackMessage="field.invalidFeedbackMessage"
                    v-model="form[field.id].$model"></InputSelect>

            <InputMultiSelect
                    :ref="field.id"
                    v-if="field.type === 'multiSelect'"
                    :id="field.id"
                    :label="field.label"
                    :options="field.options"
                    :form="form"
                    :labelCols="field.labelCols"
                    :required="field.required"
                    :autocomplete="field.autocomplete"
                    :description="field.description"
                    :_isVisible="field.isVisible"
                    @onSelect="field.onSelect"
                    :fieldRefs="fieldRefs"
                    :invalidFeedbackMessage="field.invalidFeedbackMessage"
                    v-model="form[field.id].$model"></InputMultiSelect>

            <InputPhone
                    :ref="field.id"
                    v-if="field.type === 'phone'"
                    :id="field.id"
                    :label="field.label"
                    :form="form"
                    :labelCols="field.labelCols"
                    :placeholder="field.placeholder"
                    :required="field.required"
                    :autocomplete="field.autocomplete"
                    :description="field.description"
                    :invalidFeedbackMessage="field.invalidFeedbackMessage"
                    :_isVisible="field.isVisible"
                    v-model="form[field.id].$model"></InputPhone>

            <InputCCNumber
                    :ref="field.id"
                    v-if="field.type === 'CCNumber'"
                    :id="field.id"
                    :label="field.label"
                    :form="form"
                    :labelCols="field.labelCols"
                    :placeholder="field.placeholder"
                    :required="field.required"
                    :autocomplete="field.autocomplete"
                    :description="field.description"
                    :invalidFeedbackMessage="field.invalidFeedbackMessage"
                    :_isVisible="field.isVisible"
                    v-model="form[field.id].$model"></InputCCNumber>

            <InputCCExp
                    :ref="field.id"
                    v-if="field.type === 'CCExp'"
                    :id="field.id"
                    :label="field.label"
                    :form="form"
                    :labelCols="field.labelCols"
                    :placeholder="field.placeholder"
                    :required="field.required"
                    :autocomplete="field.autocomplete"
                    :description="field.description"
                    :invalidFeedbackMessage="field.invalidFeedbackMessage"
                    :_isVisible="field.isVisible"
                    v-model="form[field.id].$model"></InputCCExp>

            <InputCC
                    :ref="field.id"
                    v-if="field.type === 'CC'"
                    :id="field.id"
                    :form="form"
                    :fieldRefs="fieldRefs"
                    :placeholder="field.placeholder"
                    :onTokenizationSuccess="field.onTokenizationSuccess"
                    :required="field.required"
                    :description="field.description"
                    :invalidFeedbackMessage="field.invalidFeedbackMessage"
                    :_isVisible="field.isVisible"
                    v-model="form[field.id].$model"></InputCC>

            <InputMask
                    :ref="field.id"
                    v-if="field.type === 'mask'"
                    :id="field.id"
                    :label="field.label"
                    :form="form"
                    :required="field.required"
                    :invalidFeedbackMessage="field.invalidFeedbackMessage"
                    :mask="field.mask"
                    :labelCols="field.labelCols"
                    :placeholder="field.placeholder"
                    :guide="field.guide"
                    :placeholderChar="field.placeholderChar"
                    :showMask="field.showMask"
                    :autocomplete="field.autocomplete"
                    :description="field.description"
                    :keepCharPositions="field.keepCharPositions"
                    :_isVisible="field.isVisible"
                    v-model="form[field.id].$model"></InputMask>

            <InputCountry
                    :ref="field.id"
                    v-if="field.type === 'country'"
                    :id="field.id"
                    :label="field.label"
                    @onSelect="field.onSelect"
                    :options="field.options"
                    :form="form"
                    :labelCols="field.labelCols"
                    :required="field.required"
                    :description="field.description"
                    :fieldRefs="fieldRefs"
                    :invalidFeedbackMessage="field.invalidFeedbackMessage"
                    :_isVisible="field.isVisible"
                    v-model="form[field.id].$model"></InputCountry>

            <InputProvince
                    :ref="field.id"
                    v-if="field.type === 'province'"
                    :id="field.id"
                    :label="field.label"
                    :options="field.options"
                    :form="form"
                    :labelCols="field.labelCols"
                    :required="field.required"
                    :description="field.description"
                    :invalidFeedbackMessage="field.invalidFeedbackMessage"
                    :_isVisible="field.isVisible"
                    v-model="form[field.id].$model"></InputProvince>

            <InputAvatar
                    :ref="field.id"
                    v-if="field.type === 'avatar'"
                    :id="field.id"
                    :form="form"
                    :label="field.label"
                    :description="field.description"
                    :labelCols="field.labelCols"
                    :cropperOptions="field.cropperOptions"
                    :_isVisible="field.isVisible"
                    v-model="form[field.id].$model"></InputAvatar>

            <InputFiles
                    :ref="field.id"
                    v-if="field.type === 'image'"
                    :multiple="false"
                    :allowedTypes="Core.File.imageTypes()"
                    :id="field.id"
                    :form="form"
                    :placeholder="field.placeholder"
                    :label="field.label"
                    :description="field.description"
                    :labelCols="field.labelCols"
                    :thumbnailWidth="field.thumbnailWidth"
                    :maxFilesize="field.maxFilesize"
                    v-model="form[field.id].$model"></InputFiles>

            <InputFiles
                    :ref="field.id"
                    v-if="field.type === 'images'"
                    :multiple="true"
                    :allowedTypes="Core.File.imageTypes()"
                    :id="field.id"
                    :form="form"
                    :placeholder="field.placeholder"
                    :label="field.label"
                    :description="field.description"
                    :labelCols="field.labelCols"
                    v-model="form[field.id].$model"></InputFiles>

            <InputFiles
                    :ref="field.id"
                    v-if="field.type === 'files'"
                    :multiple="true"
                    :id="field.id"
                    :form="form"
                    :placeholder="field.placeholder"
                    :label="field.label"
                    :description="field.description"
                    :labelCols="field.labelCols"
                    v-model="form[field.id].$model"></InputFiles>

            <InputFiles
                    :ref="field.id"
                    v-if="field.type === 'file'"
                    :multiple="false"
                    :id="field.id"
                    :form="form"
                    :placeholder="field.placeholder"
                    :label="field.label"
                    :description="field.description"
                    :labelCols="field.labelCols"
                    v-model="form[field.id].$model"></InputFiles>

            <InputCheckbox
                    :ref="field.id"
                    v-if="field.type === 'checkbox'"
                    :id="field.id"
                    :label="field.label"
                    :form="form"
                    :labelCols="field.labelCols"
                    :class="field.class"
                    :required="field.required"
                    :description="field.description"
                    :_isVisible="field.isVisible"
                    :onChange="field.onChange"
                    :fieldRefs="fieldRefs"
                    :invalidFeedbackMessage="field.invalidFeedbackMessage"
                    v-model="form[field.id].$model"></InputCheckbox>

            <InputCurrency
                    :ref="field.id"
                    v-if="field.type === 'currency'"
                    :id="field.id"
                    :label="field.label"
                    :form="form"
                    :placeholder="field.placeholder"
                    :labelCols="field.labelCols"
                    :required="field.required"
                    :autocomplete="field.autocomplete"
                    :description="field.description"
                    :invalidFeedbackMessage="field.invalidFeedbackMessage"
                    v-model="form[field.id].$model"></InputCurrency>

            <InputLongText
                    :ref="field.id"
                    v-if="field.type === 'longText'"
                    :id="field.id"
                    :label="field.label"
                    :form="form"
                    :placeholder="field.placeholder"
                    :labelCols="field.labelCols"
                    :required="field.required"
                    :autocomplete="field.autocomplete"
                    :multiLingual="field.multiLingual"
                    :description="field.description"
                    :invalidFeedbackMessage="field.invalidFeedbackMessage"
                    :_isVisible="field.isVisible"
                    v-model="form[field.id].$model"></InputLongText>

            <InputEditor
                    :ref="field.id"
                    v-if="field.type === 'editor'"
                    :id="field.id"
                    :label="field.label"
                    :form="form"
                    :placeholder="field.placeholder"
                    :labelCols="field.labelCols"
                    :required="field.required"
                    :autocomplete="field.autocomplete"
                    :multiLingual="field.multiLingual"
                    :description="field.description"
                    :invalidFeedbackMessage="field.invalidFeedbackMessage"
                    v-model="form[field.id].$model"></InputEditor>

            <InputNumber
                    :ref="field.id"
                    v-if="field.type === 'number'"
                    :id="field.id"
                    :label="field.label"
                    :form="form"
                    :placeholder="field.placeholder"
                    :required="field.required"
                    :autocomplete="field.autocomplete"
                    :description="field.description"
                    :labelCols="field.labelCols"
                    :invalidFeedbackMessage="field.invalidFeedbackMessage"
                    :_isVisible="field.isVisible"
                    v-model="form[field.id].$model"></InputNumber>

            <InputColor
                    :ref="field.id"
                    v-if="field.type === 'color'"
                    :id="field.id"
                    :label="field.label"
                    :form="form"
                    :placeholder="field.placeholder"
                    :required="field.required"
                    :autocomplete="field.autocomplete"
                    :description="field.description"
                    :labelCols="field.labelCols"
                    :mode="field.mode"
                    :invalidFeedbackMessage="field.invalidFeedbackMessage"
                    :_isVisible="field.isVisible"
                    v-model="form[field.id].$model"></InputColor>

            <InputQuantity
                    :ref="field.id"
                    v-if="field.type === 'quantity'"
                    :id="field.id"
                    :label="field.label"
                    :form="form"
                    :required="field.required"
                    :placeholder="field.placeholder"
                    :autocomplete="field.autocomplete"
                    :description="field.description"
                    :labelCols="field.labelCols"
                    :invalidFeedbackMessage="field.invalidFeedbackMessage"
                    :_isVisible="field.isVisible"
                    v-model="form[field.id].$model"></InputQuantity>

            <InputTime
                    :ref="field.id"
                    v-if="field.type === 'time'"
                    :id="field.id"
                    :label="field.label"
                    :form="form"
                    :required="field.required"
                    :placeholder="field.placeholder"
                    :autocomplete="field.autocomplete"
                    :description="field.description"
                    :labelCols="field.labelCols"
                    :_isVisible="field.isVisible"
                    :invalidFeedbackMessage="field.invalidFeedbackMessage"
                    v-model="form[field.id].$model"></InputTime>

            <InputDateRangePicker
                    :ref="field.id"
                    v-if="field.type === 'dateRangePicker'"
                    :id="field.id"
                    :label="field.label"
                    :form="form"
                    :required="field.required"
                    :placeholder="field.placeholder"
                    :autocomplete="field.autocomplete"
                    :description="field.description"
                    :labelCols="field.labelCols"
                    :presets="field.presets"
                    :isInline="field.isInline"
                    :invalidFeedbackMessage="field.invalidFeedbackMessage"
                    v-model="form[field.id].$model"></InputDateRangePicker>

            <InputDatePicker
                    :ref="field.id"
                    v-if="field.type === 'datePicker'"
                    :id="field.id"
                    :label="field.label"
                    :form="form"
                    :fieldRefs="fieldRefs"
                    :required="field.required"
                    :placeholder="field.placeholder"
                    :autocomplete="field.autocomplete"
                    :description="field.description"
                    :labelCols="field.labelCols"
                    :isInline="field.isInline"
                    :readOnly="field.readOnly"
                    @onChange="field.onChange"
                    :invalidFeedbackMessage="field.invalidFeedbackMessage"
                    :_isVisible="field.isVisible"
                    v-model="form[field.id].$model"></InputDatePicker>

            <Title
                    :ref="field.id"
                    v-if="field.type === 'title'"
                    :label="field.label"
                    :tag="field.tag"
                    :form="form"
                    :description="field.description"></Title>

            <CCBrands
                    :ref="field.id"
                    :class="field.class"
                    :labelCols="field.labelCols"
                    v-if="field.type === 'CCBrands'">
            </CCBrands>

            <CCDefault
                    :ref="field.id"
                    :class="field.class"
                    :form="form"
                    :fieldRefs="fieldRefs"
                    v-model="form[field.id].$model"
                    v-if="field.type === 'CCDefault'">
            </CCDefault>

            <Separator
                    :ref="field.id"
                    :class="field.class"
                    v-if="field.type === 'separator'">
            </Separator>

            <ProductData
                    :ref="field.id"
                    :id="field.id"
                    :class="field.class"
                    v-model="form[field.id].$model"
                    :form="form"
                    v-if="field.type === 'productData'">
            </ProductData>

            <Payments
                    :ref="field.id"
                    :id="field.id"
                    :class="field.class"
                    v-model="form[field.id].$model"
                    :total="field.total"
                    :forceTotal="field.forceTotal"
                    :options="field.options"
                    :form="form"
                    :calcTotalOnEval="field.calcTotalOnEval"
                    :displayCheckPayment="field.displayCheckPayment"
                    :displayMakePayment="field.displayMakePayment"
                    :displayCompletedPayment="field.displayCompletedPayment"
                    :displayFullCompletedPayment="field.displayFullCompletedPayment"
                    :displayPaymentStatus="field.displayPaymentStatus"
                    :fieldRefs="fieldRefs"
                    @onTokenizationSuccess="field.onTokenizationSuccess"
                    @onPaymentCompleted="field.onPaymentCompleted"
                    @onCheckPayment="field.onCheckPayment"
                    v-if="field.type === 'payments'">
            </Payments>

            <DatePagination
                    :ref="field.id"
                    :id="field.id"
                    :class="field.class"
                    v-model="form[field.id].$model"
                    :total="field.total"
                    :form="form"
                    :fieldRefs="fieldRefs"
                    v-if="field.type === 'datePagination'">
            </DatePagination>

            <ProductMultipleTypeSummary
                    :ref="field.id"
                    :id="field.id"
                    :class="field.class"
                    v-model="form[field.id].$model"
                    :form="form"
                    :fieldRefs="fieldRefs"
                    :updateTotal="field.updateTotal"
                    v-if="field.type === 'productMultipleTypeSummary'">
            </ProductMultipleTypeSummary>

            <ProductStandardSummary
                    :ref="field.id"
                    :id="field.id"
                    :caption="field.label"
                    :class="field.class"
                    v-model="form[field.id].$model"
                    :form="form"
                    :fieldRefs="fieldRefs"
                    :onChange="field.onChange"
                    :updateTotal="field.updateTotal"
                    :onMinus="field.onMinus"
                    :onPlus="field.onPlus"
                    :required="field.required"
                    :invalidFeedbackMessage="field.invalidFeedbackMessage"
                    v-if="field.type === 'productStandardSummary'">
            </ProductStandardSummary>

            <ProductLimitedSubscriptionSummary
                    :ref="field.id"
                    :id="field.id"
                    :caption="field.label"
                    :class="field.class"
                    v-model="form[field.id].$model"
                    :form="form"
                    :fieldRefs="fieldRefs"
                    :onChange="field.onChange"
                    :updateTotal="field.updateTotal"
                    :required="field.required"
                    :invalidFeedbackMessage="field.invalidFeedbackMessage"
                    v-if="field.type === 'productLimitedSubscriptionSummary'">
            </ProductLimitedSubscriptionSummary>

            <ProductRecurringSubscriptionSummary
                    :ref="field.id"
                    :id="field.id"
                    :caption="field.label"
                    :class="field.class"
                    v-model="form[field.id].$model"
                    :form="form"
                    :fieldRefs="fieldRefs"
                    :onChange="field.onChange"
                    :onEvalPayments="field.onEvalPayments"
                    :updateTotal="field.updateTotal"
                    v-if="field.type === 'productRecurringSubscriptionSummary'">
            </ProductRecurringSubscriptionSummary>

            <Summary
                    :ref="field.id"
                    :id="field.id"
                    :caption="field.label"
                    :class="field.class"
                    v-model="form[field.id].$model"
                    :form="form"
                    :fieldRefs="fieldRefs"
                    :onChange="field.onChange"
                    :updateTotal="field.updateTotal"
                    v-if="field.type === 'summary'">
            </Summary>

            <BookingSummary
                    :ref="field.id"
                    :id="field.id"
                    :class="field.class"
                    v-model="form[field.id].$model"
                    :form="form"
                    :fieldRefs="fieldRefs"
                    v-if="field.type === 'bookingSummary'">
            </BookingSummary>

            <BookingPurchaseSummary
                    :ref="field.id"
                    :id="field.id"
                    :class="field.class"
                    v-model="form[field.id].$model"
                    :form="form"
                    :fieldRefs="fieldRefs"
                    v-if="field.type === 'bookingPurchaseSummary'">
            </BookingPurchaseSummary>

            <UserAction
                    :ref="field.id"
                    :id="field.id"
                    :class="field.class"
                    v-model="form[field.id].$model"
                    @updateUser="field.updateUser"
                    :total="field.total"
                    :form="form"
                    :fieldRefs="fieldRefs"
                    v-if="field.type === 'userAction'">
            </UserAction>

            <Html
                    :ref="field.id"
                    :id="field.id"
                    :class="field.class"
                    :html="field.html"
                    v-if="field.type === 'html'">
            </Html>

            <div  v-if="field.type === 'spreadsheet'">

            </div>

            <div class="hot-table-container" v-if="field.type === Core.Value.typeSpreadsheet">

                <div :ref="field.id" :id="field.id"></div>

                <!--
                <hot-table
                    :ref="field.id"
                    :id="field.id"
                    :data="form[field.id].$model"
                    v-if="field.type === 'spreadsheet'"
                    :formulas="true"
                    :contextMenu="dataSpreadsheet.contextMenu"
                    :mergeCells="field.data.spreadsheet.settings.mergeCells"
                    :colWidths="field.data.spreadsheet.settings.colWidths"
                    :cell="field.data.spreadsheet.settings.cellMetas"
                    :manualColumnResize="dataSpreadsheet.manualColumnResize"
                    :rowHeaders="dataSpreadsheet.rowHeaders"
                    :colHeaders="dataSpreadsheet.colHeaders"
                    :settings="dataSpreadsheet.settings"
                    :cells="dataSpreadsheet.cells"
                    licenseKey="non-commercial-and-evaluation">
            </hot-table>-->
            </div>


        </div>
    </div>

</template>
<script>
    import InputText from './InputText'
    import InputHidden from './InputHidden'
    import InputCurrency from './InputCurrency'
    import InputPassword from './InputPassword'
    import InputPhone from './InputPhone'
    import InputDate from './InputDate'
    import InputNumber from './InputNumber'
    import InputMask from './InputMask'
    import InputSelect from './InputSelect'
    import InputMultiSelect from './InputMultiSelect'
    import InputCCExp from './InputCCExp'
    import InputCCNumber from './InputCCNumber'
    import InputCountry from './InputCountry'
    import InputProvince from './InputProvince'
    import InputCheckbox from './InputCheckbox'
    import InputCC from './InputCC'
    import InputNotes from './InputNotes'
    import InputAvatar from './InputAvatar'
    import InputFiles from './InputFiles'
    import InputLongText from './InputLongText'
    import InputEditor from './InputEditor'
    import InputColor from './InputColor'
    import InputQuantity from './InputQuantity'
    import InputTime from './InputTime'
    import InputDateRangePicker from './InputDateRangePicker'
    import InputDatePicker from './InputDatePicker'
    import InputScanText from './InputScanText'
    import InputAddress from './InputAddress'
    import InputItems from './InputItems'
    import InputSignature from './InputSignature'
    import InputSignatureImage from './InputSignatureImage'
    import InputHTML from './InputHTML'

    //FLAG Comment those bitches when you build the widget.
    import { HotTable } from '@handsontable/vue';
    import { HyperFormula } from 'hyperformula';
    import InputInstanceSelector from './InputInstanceSelector'
    import InputMultipleInstanceSelector from './InputMultipleInstanceSelector'
    import CCDefault from './CCDefault'
    import CCBrands from './CCBrands'
    import Separator from './Separator';
    import Title from './Title'
    import ProductData from './ProductData'
    import Payments from './Payments'
    import ProductStandardSummary from './ProductStandardSummary'
    import UserAction from './UserAction'
    import ProductLimitedSubscriptionSummary from './ProductLimitedSubscriptionSummary'
    import ProductRecurringSubscriptionSummary from './ProductRecurringSubscriptionSummary'
    import BookingSummary from './BookingSummary'
    import BookingPurchaseSummary from './BookingPurchaseSummary'
    import DatePagination from './DatePagination'
    import ProductMultipleTypeSummary from './ProductMultipleTypeSummary'
    import Html from './Html'
    import Summary from './Summary'
    import RequestButton from './RequestButton'
    import ActionButton from './ActionButton'
    import Alert from './Alert'
    import Spreadsheet from './Spreadsheet'


    export default {
        name: 'FormFields',
        get component() {
            return [

            ]
        },
        components: {
            InputLongText,
            InputText,
            InputSelect,
            InputPhone,
            InputDate,
            InputNumber,
            InputMask,
            InputMultiSelect,
            InputCCExp,
            InputCCNumber,
            InputCountry,
            InputProvince,
            InputPassword,
            InputDateRangePicker,
            InputDatePicker,
            InputCheckbox,
            InputCC,
            InputNotes,
            InputAvatar,
            InputCurrency,
            InputColor,
            InputQuantity,
            InputTime,
            InputHidden,
            InputScanText,
            InputAddress,
            InputItems,
            InputFiles,
            InputEditor,
            InputSignature,
            InputHTML,
            // Comment those bitches when you build the widget.
            InputInstanceSelector,
            InputMultipleInstanceSelector,
            Title,
            CCBrands,
            CCDefault,
            Separator,
            ProductData,
            Payments,
            ProductStandardSummary,
            ProductLimitedSubscriptionSummary,
            ProductRecurringSubscriptionSummary,
            ProductMultipleTypeSummary,
            UserAction,
            BookingSummary,
            BookingPurchaseSummary,
            DatePagination,
            Html,
            Summary,
            RequestButton,
            ActionButton,
            Alert,
            Spreadsheet,
            HotTable,
            InputSignatureImage
        },
        mounted() {
            this.dataFieldRefs = this.value
            for (let field in this.fields) {
                field = this.fields[field]
                if (field.id !== undefined && this.$refs !== undefined && this.$refs[field.id] !== undefined && this.$refs[field.id][0] !== undefined) {
                    this.fieldRefs[field.id] = this.$refs[field.id][0]
                    this.dataFieldRefs[field.id] = this.$refs[field.id][0]
                }

                if (field.type === Core.Value.typeSpreadsheet) {
                    let id = field.id
                    let container = document.getElementById(id)
                    if (container.hotInstance === undefined) {
                        Core.Spreadsheet.init(container, field)
                    }
                }
            }
        },
        props: {
            fields: {
                type: Array | Object,
                default: function () {
                    return []
                }
            },
            form: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            fieldRefs: {
                type: Array | Object,
                default: function () {
                    return []
                }
            },
            value: {
                type: Array | Object,
                default: function() { return [] }
            }
        },
        watch: {
            value(val) {
                this.dataFieldRefs = val
            },
            dataFieldRefs(val) {
                this.$emit('input', val)
            }
        },
        data: function () {
            return {
                dataFieldRefs: [],
                Core: window.Core,
            }
        }
    }
</script>

